import { FormikProps } from 'formik';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { default as NavigationFooter } from '../../../components/NavigationFooter/NavigationFooter';
import { updateBusinessAddressAndTaxes } from '../../../services/commerce.service';
import { CommerceAddressState } from '../../../types/add_commerce.types';
import { AddressTaxesRequest } from '../../../types/business/request';
import { triggerToasts } from '../../../utils/helpers';
import { pagesPaths } from '../../../utils/navigationUtils';

function AddressFooter({
  formRef,
  localState,
  addressRequest,
}: {
  formRef: React.MutableRefObject<FormikProps<any> | null>;
  localState: CommerceAddressState;
  addressRequest: AddressTaxesRequest | null;
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const handleProceed = () => formRef?.current?.handleSubmit();

  const handleGoBack = () => {
    navigate(pagesPaths.CommerceInformation, { state: { ...localState } });
  };

  useEffect(() => {
    if (!addressRequest) return;

    const updateAddressAndTaxes = async () => {
      setLoading(true);
      const response = await updateBusinessAddressAndTaxes(localState.id!, addressRequest);

      if (response.result && response.data) {
        const businessData = response.data.businessData || response.data;

        return navigate(pagesPaths.CommerceBranches, { state: { ...localState, ...businessData } });
      }
      triggerToasts(response);
      setLoading(false);
    };

    updateAddressAndTaxes();
  }, [addressRequest, setLoading, localState, navigate]);

  return <NavigationFooter previousHandler={handleGoBack} nextHandler={handleProceed} loading={loading} />;
}

export default AddressFooter;
